import React from "react";
import { dialogStyles } from "../../../../../Constants/dialogStyles";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@mui/material";
import { textButtonStyles } from "../../../../../Constants/buttonStyles";

const InactiveUsersNotice = ({
  inactiveUsersDialogOpen,
  handleDialogClose,
}) => {
  return (
    <Dialog
      open={inactiveUsersDialogOpen}
      onClose={handleDialogClose}
      PaperProps={{ sx: dialogStyles.dialogRoot }}
    >
      <DialogTitle sx={{ ...dialogStyles.dialogTitle, mb: 2 }}>
        Inactive Users Notice
      </DialogTitle>
      <DialogContent sx={dialogStyles.dialogContent}>
        <DialogContentText sx={dialogStyles.dialogContentText}>
          Some users are inactive because the number of users exceeds the
          subscription limit. You can activate the user by proceeding to
          checkout button.
        </DialogContentText>
      </DialogContent>
      <DialogActions sx={dialogStyles.dialogActions}>
        <Button onClick={handleDialogClose} sx={textButtonStyles}>
          OK
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default InactiveUsersNotice;
